export interface Project {
  id: number;
  title: string;
  location: string;
  image: string;
  category: string;
  year?: string;
  client?: string;
  duration?: string;
  area?: string;
  description?: string;
  scope?: string[];
  gallery?: string[];
}

export const projects: Project[] = [
  {
    id: 1,
    title: "Eskişehir Sivrihisar Projesi",
    location: "Eskişehir",
    image: "/images/projects/Eskisehir_Sivrihisar/sivrihisar17.jpg",
    category: "İnşaat",
    year: "2022",
    client: "Özel Sektör",
    duration: "8 Ay",
    area: "2.400 m²",
    description: "Eskişehir Sivrihisar bölgesinde gerçekleştirilen bu proje, modern inşaat teknikleri ve ince işçilik anlayışıyla hayata geçirilmiştir. Yapı, dayanıklı malzemeler ve estetik tasarım anlayışıyla bölgenin en dikkat çekici projelerinden biri haline gelmiştir. Güvenli Dizayn ekibi, projenin her aşamasında kalite standartlarından ödün vermeden çalışmıştır.",
    scope: ["Kaba İnşaat", "İnce İşçilik", "İç Dekorasyon", "Zemin Kaplama", "Alçı & Sıva"],
    gallery: [
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar1.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar2.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar3.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar4.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar5.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar6.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar7.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar8.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar9.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar10.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar12.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar13.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar14.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar15.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar16.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar17.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar18.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar19.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar20.jpg",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar_video.mp4",
      "/images/projects/Eskisehir_Sivrihisar/sivrihisar_video2.mp4",
    ],
  },
  {
    id: 11,
    title: "Kuşadası Taş Duvar",
    location: "Aydın / Kuşadası",
    image: "/images/projects/Kusadasi_Duvar/Kusadasi_Duvar_1.jpeg",
    category: "Taş Duvar & Peyzaj",
    year: "2026",
    client: "Özel Sektör",
    duration: "3 Ay",
    description: "Kuşadası'nda gerçekleştirilen taş duvar örme projemiz başarıyla tamamlanmıştır. Doğal taşın estetik güzelliği ile ustalıkla harmanlanmış bu proje, geleneksel taş duvar örme sanatını modern uygulamalarla buluşturmaktadır. Güvenli Dizayn'ın deneyimli ustaları, her taşı titizlikle seçerek sağlam, estetik ve uzun ömürlü bir yapı ortaya koymuştur. Kuşadası'nın doğal dokusuna uyum sağlayan bu çalışma, hem işlevselliği hem de görsel kaliteyi en üst düzeyde sunan ekibimizin profesyonelliğinin somut bir göstergesidir.",
    scope: ["Doğal Taş Seçimi", "Taş Duvar Örme", "Derz & Fugalama", "Temel Hazırlık", "Çevre Düzenlemesi"],
    gallery: [
      "/images/projects/Kusadasi_Duvar/Kusadasi_Duvar_1.jpeg",
      "/images/projects/Kusadasi_Duvar/Kusadasi_Duvar_2.jpeg",
      "/images/projects/Kusadasi_Duvar/Kusadasi_Duvar_3.jpeg",
      "/images/projects/Kusadasi_Duvar/Kusadasi_Duvar_4.jpeg",
    ],
  },
  {
    id: 3,
    title: "Afyon TEİAŞ GIS",
    location: "Afyonkarahisar",
    image: "/images/projects/Afyonkarahisar_TEIAS_GIS/Afyon1.jpg",
    category: "GIS Projesi",
    year: "2020",
    client: "TEİAŞ",
    duration: "14 Ay",
    area: "4.200 m²",
    description: "Afyonkarahisar'da inşa edilen GIS (Gaz İzoleli Şalt) tesisi, modern enerji altyapısının en önemli bileşenlerinden birini oluşturmaktadır. Güvenli Dizayn, bu projede yüksek teknik standartlar gerektiren GIS bina inşaatını, iç dekorasyon ve teknik altyapı çalışmalarını başarıyla tamamlamıştır.",
    scope: ["GIS Bina İnşaatı", "Teknik Zemin", "İç Kaplama", "Isı & Ses Yalıtımı", "Elektrik Tesisatı"],
    gallery: [
      "/images/projects/Afyonkarahisar_TEIAS_GIS/Afyon1.jpg",
      "/images/projects/Afyonkarahisar_TEIAS_GIS/Afyon2.jpg",
      "/images/projects/Afyonkarahisar_TEIAS_GIS/Afyon3.jpg",
      "/images/projects/Afyonkarahisar_TEIAS_GIS/Afyon4.jpg",
      "/images/projects/Afyonkarahisar_TEIAS_GIS/Afyon5.jpg",
      "/images/projects/Afyonkarahisar_TEIAS_GIS/Afyon6.jpg",
    ],
  },
  {
    id: 4,
    title: "Bilecik Safi Çimento",
    location: "Bilecik",
    image: "/images/projects/Bilecik_SafiCimento/bilecik4.jpg",
    category: "Endüstriyel",
    year: "2025",
    client: "Safi Çimento A.Ş.",
    duration: "10 Ay",
    area: "5.600 m²",
    description: "Bilecik'te faaliyet gösteren Safi Çimento fabrikasının tadilat ve iç dekorasyon projesini Güvenli Dizayn üstlenmiştir. Endüstriyel ortamın zorlu koşullarına uygun malzemeler kullanılarak gerçekleştirilen bu projede, üretim alanları, idari binalar ve sosyal tesisler yenilenerek modern bir görünüme kavuşturulmuştur.",
    scope: ["Fabrika Tadilat", "İdari Bina Renovasyonu", "Zemin Kaplama", "Tavan Sistemleri", "Boya & Badana"],
    gallery: [
      "/images/projects/Bilecik_SafiCimento/bilecik1.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik2.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik3.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik4.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik5.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik6.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik7.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik8.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik9.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik10.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik11.jpg",
      "/images/projects/Bilecik_SafiCimento/bilecik_video1.mp4",
      "/images/projects/Bilecik_SafiCimento/bilecik_video2.mp4",
    ],
  },
  {
    id: 5,
    title: "Eskişehir GIS",
    location: "Eskişehir",
    image: "/images/projects/Eskisehir_GIS/Eskisehir_GIS2.jpg",
    category: "GIS Projesi",
    year: "2024",
    client: "TEİAŞ",
    duration: "11 Ay",
    area: "3.500 m²",
    description: "Eskişehir GIS projesi, bölgenin enerji iletim altyapısını güçlendirmek amacıyla hayata geçirilmiştir. Modern GIS teknolojisine uygun bina inşaatı ve iç mekan düzenlemeleri Güvenli Dizayn tarafından gerçekleştirilmiştir. Proje, zamanında ve bütçe dahilinde tamamlanarak müşteri memnuniyetiyle teslim edilmiştir.",
    scope: ["GIS Bina İnşaatı", "İnce İşçilik", "Teknik Zemin", "Çevre Düzenlemesi", "Güvenlik Çiti"],
    gallery: [
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS1.jpg",
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS2.jpg",
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS3.jpg",
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS4.jpg",
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS5.jpg",
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS6.jpg",
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS7.jpg",
      "/images/projects/Eskisehir_GIS/Eskisehir_GIS8.jpg",
    ],
  },
  {
    id: 2,
    title: "Adana TEİAŞ",
    location: "Adana",
    image: "/images/projects/proj2.jpg",
    category: "Elektrik Altyapı",
    year: "2021",
    client: "TEİAŞ",
    duration: "12 Ay",
    area: "3.800 m²",
    description: "Adana TEİAŞ projesi, Türkiye Elektrik İletim A.Ş. için gerçekleştirilen kapsamlı bir enerji altyapı inşaatıdır. Proje kapsamında trafo merkezi binası, idari bina ve teknik altyapı tesisleri eksiksiz tamamlanmıştır. Yüksek güvenlik standartları ve teknik gereksinimler doğrultusunda hayata geçirilen bu proje, bölgenin enerji ihtiyacına önemli katkı sağlamaktadır.",
    scope: ["Trafo Merkezi İnşaatı", "İdari Bina", "Teknik Altyapı", "Çevre Düzenlemesi", "Güvenlik Sistemleri"],
    gallery: [
      "/images/projects/gallery/proj2g1.jpg",
      "/images/projects/gallery/proj2g2.jpg",
      "/images/projects/gallery/proj2g3.jpg",
    ],
  },
  {
    id: 7,
    title: "Karaman TEİAŞ",
    location: "Karaman",
    image: "/images/projects/Karaman_TEIAS/Karaman1.jpg",
    category: "Elektrik Altyapı",
    year: "2024",
    client: "TEİAŞ",
    duration: "9 Ay",
    area: "2.900 m²",
    description: "Karaman TEİAŞ projesi, Orta Anadolu bölgesinin enerji altyapısını güçlendirmeye yönelik önemli bir yatırımdır. Güvenli Dizayn, trafo merkezi binası ve yardımcı tesislerin inşaatını yüksek kalite standartlarında tamamlamıştır.",
    scope: ["Trafo Merkezi", "İdari Bina", "Güvenlik Binası", "Çevre Düzenlemesi", "Altyapı"],
    gallery: [
      "/images/projects/Karaman_TEIAS/Karaman1.jpg",
      "/images/projects/Karaman_TEIAS/Karaman2.jpg",
      "/images/projects/Karaman_TEIAS/Karaman3.jpg",
      "/images/projects/Karaman_TEIAS/Karaman4.jpg",
      "/images/projects/Karaman_TEIAS/Karaman5.jpg",
      "/images/projects/Karaman_TEIAS/Karaman6.jpg",
      "/images/projects/Karaman_TEIAS/Karaman7.jpg",
      "/images/projects/Karaman_TEIAS/Karaman8.jpg",
      "/images/projects/Karaman_TEIAS/Karaman9.jpg",
      "/images/projects/Karaman_TEIAS/Karaman10.jpg",
      "/images/projects/Karaman_TEIAS/Karaman11.jpg",
      "/images/projects/Karaman_TEIAS/Karaman12.jpg",
      "/images/projects/Karaman_TEIAS/Karaman13.jpg",
      "/images/projects/Karaman_TEIAS/Karaman14.jpg",
      "/images/projects/Karaman_TEIAS/Karaman15.jpg",
    ],
  },
  {
    id: 8,
    title: "Sivas Zara Türk Telekom",
    location: "Sivas",
    image: "/images/projects/Sivas_Zara_Turk_Telekom/Sivas1.jpg",
    category: "Telekomünikasyon",
    year: "2023",
    client: "Türk Telekom",
    duration: "7 Ay",
    area: "1.800 m²",
    description: "Sivas Zara'da Türk Telekom için gerçekleştirilen bu proje, telekomünikasyon altyapı binasının inşaatı ve iç mekan düzenlemelerini kapsamaktadır. Güvenli Dizayn, teknik gereksinimlere tam uyumlu bir şekilde projeyi tamamlamış; modern ofis alanları ve teknik odalar titizlikle hazırlanmıştır.",
    scope: ["Teknik Bina İnşaatı", "Ofis Renovasyonu", "Teknik Oda Düzenlemesi", "Zemin Kaplama", "Asma Tavan"],
    gallery: [
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas1.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas2.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas3.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas4.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas5.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas6.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas7.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas8.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas9.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas10.jpg",
      "/images/projects/Sivas_Zara_Turk_Telekom/Sivas11.jpg",
    ],
  },
  {
    id: 9,
    title: "Tekirdağ TEİAŞ",
    location: "Tekirdağ",
    image: "/images/projects/Tekirdag_TEIAS/Tekirdag9.jpg",
    category: "Elektrik Altyapı",
    year: "2023",
    client: "TEİAŞ",
    duration: "10 Ay",
    area: "3.200 m²",
    description: "Tekirdağ TEİAŞ projesi, Trakya bölgesinin enerji iletim altyapısını modernize etmeye yönelik stratejik bir yatırımdır. Güvenli Dizayn, bu projede trafo merkezi binası ve tüm yardımcı tesislerin inşaatını başarıyla tamamlamıştır.",
    scope: ["Trafo Merkezi", "Kontrol Binası", "Güvenlik Tesisleri", "Çevre Düzenlemesi", "Yol & Altyapı"],
    gallery: [
      "/images/projects/Tekirdag_TEIAS/Tekirdag1.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag2.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag3.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag4.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag5.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag6.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag7.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag8.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag9.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag10.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag11.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag12.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag13.jpg",
      "/images/projects/Tekirdag_TEIAS/Tekirdag14.jpg",
    ],
  },
  {
    id: 10,
    title: "Trabzon TEİAŞ GIS",
    location: "Trabzon",
    image: "/images/projects/Trabzon/Trabzon3.jpg",
    category: "GIS Projesi",
    year: "2023",
    client: "TEİAŞ",
    duration: "15 Ay",
    area: "5.100 m²",
    description: "Trabzon TEİAŞ GIS projesi, Karadeniz bölgesinin en kapsamlı enerji altyapı projelerinden biridir. Güvenli Dizayn, zorlu coğrafi koşullara rağmen projeyi zamanında ve yüksek kalite standartlarında tamamlamıştır.",
    scope: ["GIS Bina İnşaatı", "İdari Bina", "Teknik Altyapı", "Peyzaj & Çevre", "Güvenlik Sistemleri"],
    gallery: [
      "/images/projects/Trabzon/Trabzon1.jpg",
      "/images/projects/Trabzon/Trabzon2.jpg",
      "/images/projects/Trabzon/Trabzon3.jpg",
      "/images/projects/Trabzon/Trabzon4.jpg",
      "/images/projects/Trabzon/Trabzon5.jpg",
      "/images/projects/Trabzon/Trabzon6.jpg",
      "/images/projects/Trabzon/Trabzon7.jpg",
      "/images/projects/Trabzon/Trabzon8.jpg",
    ],
  },
  {
    id: 12,
    title: "Zonguldak TEİAŞ",
    location: "Zonguldak",
    image: "/images/projects/proj11.jpg",
    category: "Elektrik Altyapı",
    year: "2024",
    client: "TEİAŞ",
    duration: "12 Ay",
    area: "3.700 m²",
    description: "Zonguldak TEİAŞ projesi, Karadeniz bölgesinin enerji altyapısını güçlendirmeye yönelik bu proje, modern inşaat teknikleri ve deneyimli ekibimizle titizlikle hayata geçirilmektedir.",
    scope: ["Trafo Merkezi", "GIS Binası", "İdari Tesis", "Altyapı Çalışmaları", "Çevre Düzenlemesi"],
    gallery: [
      "/images/projects/gallery/proj11g1.jpg",
      "/images/projects/gallery/proj11g2.jpg",
      "/images/projects/gallery/proj11g3.jpg",
    ],
  },
  {
    id: 6,
    title: "İzmir GIS",
    location: "İzmir",
    image: "/images/projects/proj6.jpg",
    category: "GIS Projesi",
    year: "2023",
    client: "TEİAŞ",
    duration: "13 Ay",
    area: "4.800 m²",
    description: "İzmir GIS projesi, Ege bölgesinin en büyük enerji altyapı projelerinden biri olma özelliği taşımaktadır. Güvenli Dizayn, bu projede yüksek teknik standartlar gerektiren GIS bina inşaatını ve tüm iç mekan düzenlemelerini başarıyla tamamlamıştır.",
    scope: ["GIS Bina İnşaatı", "İdari Bina", "Teknik Altyapı", "Peyzaj", "Güvenlik Sistemleri"],
    gallery: [
      "/images/projects/gallery/proj6g1.jpg",
      "/images/projects/gallery/proj6g2.jpg",
      "/images/projects/gallery/proj6g3.jpg",
    ],
  },
];

export const heroSlides = [
  {
    id: 1,
    projectId: 2,
    image: "/images/hero/hero1.jpg",
    title: "İnce İşçilikte Güvenilir Çözüm Ortağınız",
    subtitle: "Türkiye genelinde anahtar teslim inşaat ve dekorasyon projeleri",
  },
  {
    id: 2,
    projectId: 3,
    image: "/images/hero/hero2.jpg",
    title: "22 Yıllık Deneyimle Güçlü Projeler",
    subtitle: "TEİAŞ, Türk Telekom ve daha fazlası için tamamlanan projeler",
  },
  {
    id: 3,
    projectId: 9,
    image: "/images/hero/hero3.jpg",
    title: "Anahtar Teslim Dekorasyon Çözümleri",
    subtitle: "İç dekorasyon ve tadilat projelerinde uzman kadromuzla yanınızdayız",
  },
];
